<template>
    <div class="bg-view bg-primary p-5">
        <b-container id="view-container" class="container bg-light" fluid="lg" variant="light" type="light">
            <h1>Mot de passe oublié</h1>
            <br>
            <p>Vous avez oublié votre mot de passe ?</p>
            <p>Pas de panique, la plupart des sites internet nécessitant de s'identifier possèdent une fonctionnalité "Mot de passe oublié" permettant de créer un nouveau mot de passe.</p>
            <p>Si vous avez déjà renseigné et confirmé votre adresse email sur votre espace Digital Citizen, vous pouvez créer un nouveau mot de passe en indiquant votre adresse email dans le champ ci-dessous.</p>
            <p>Un email contenant un lien de réinitialisation de votre mot de passe vous sera alors envoyé.</p>
            <p>Si vous n'avez pas encore renseigné votre adresse dans votre espace Digital Citizen, n'hésitez pas à vous rapprocher de votre centre de formation pour vous aider à retrouver l'accès à votre compte.</p>

            <b-overlay :show="loading" spinner-variant="primary">
                <b-container>
                    <b-row align-h="center">
                        <b-form @submit.prevent="onSubmit" id="forgotten-password-form">
                            <b-col class="p-0">
                                <b-form-input
                                    type="email"
                                    id="input-email"
                                    v-model="form.email"
                                    placeholder="Votre adresse email"
                                    required
                                    class="input"
                                ></b-form-input>
                            </b-col>
                            <b-col class="p-0">
                                <b-button type="submit" :disabled="loading" variant="secondary" class="login-btn">Envoyer le lien de réinitialisation</b-button>
                            </b-col>
                        </b-form>
                    </b-row>
                </b-container>
            </b-overlay>
            <br>
            
            <b-alert :show="showAlert" :variant="alert.variant">
                {{ alert.text }}
            </b-alert>
        </b-container>
    </div>
</template>

<script>
import publicApi from '@/services/public.js'

export default {
    data() { 
        return {
            form: {email:""},
            loading: false,
            emailSent: false,
            showAlert: false
        }
    },
    computed: {
        alert() {
            if(this.emailSent) {
                return {
                    variant: "success", 
                    text: "Un lien de réinitialisation de votre mot de passe vient de vous être envoyé à l'adresse email renseignée. Veuillez consulter votre boite mail."
                }
            }
            else {
                return {
                    variant: "danger", 
                    text: "L'email de récupération de votre compte n'a pas pu vous être envoyé. Veuillez vérifier l'adresse renseignée ou vous rapprocher de votre centre de formation."
                }
            }
        }
    },
    created() {
    },
    methods: {
        async onSubmit() {
            this.loading = true
            this.showAlert = false
            await publicApi.post(`/lsa/forgotten/password`, this.form)
            .then( () => {
                this.emailSent=true
            })
            .catch( () => {
                this.emailSent=false
            })
            this.showAlert = true
            this.loading = false
        },
    }
}
</script>

<style scoped>
.container {
    font-weight: bold;
}
.btn {
    margin-top: 0.5rem
}
</style>